import api from "./apiConfig";

export const CREATE_MEETING = async (data) => {
	try {
		const response = await api.post("/meeting", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_MEETINGS_BY_ENTERPRISE = async (id) => {
	try {
		const response = await api.get(`/meetingByClient/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};
